export const reviewCardComponent = {
  key: 'reviewCardComponent',
  name: 'Review Card Dept-Component',
  siteIdentifier: 'global',

  anonymousLabel: 'Anonymous',
  productLinkLabel: 'Product Link',
};
